/* Accessibility: add accessible names to controls the theme/plugins leave unlabeled.
   Runs on load and observes DOM changes (slick carousels inject arrows after init). */
(function () {
  function label(el, name) {
    if (el && !el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
      el.setAttribute('aria-label', name);
    }
  }

  function pass() {
    // Quantity number inputs (PDP, quick view, cart) — critical: no <label>
    document.querySelectorAll('input[id^="quantity-"], input[name="quantity"], .quantity input[type="number"]').forEach(function (el) {
      label(el, 'Quantity');
    });
    // Slick carousel arrows (product gallery, sliders) rendered as <button>/<a> or wrapping <svg role="img">
    document.querySelectorAll('.slick-prev').forEach(function (el) { label(el, 'Previous'); });
    document.querySelectorAll('.slick-next').forEach(function (el) { label(el, 'Next'); });
    document.querySelectorAll('.slick-prev svg[role="img"], .slick-next svg[role="img"]').forEach(function (svg) {
      if (!svg.querySelector('title')) {
        var t = document.createElementNS('http://www.w3.org/2000/svg', 'title');
        t.textContent = svg.closest('.slick-next') ? 'Next' : 'Previous';
        svg.insertBefore(t, svg.firstChild);
      }
      svg.setAttribute('aria-hidden', 'true');
    });
    // Slick listbox / live regions without a name
    document.querySelectorAll('.slick-track[role="listbox"], .slick-list[aria-live]').forEach(function (el) {
      label(el, 'Product images');
    });
    // Video popup trigger
    document.querySelectorAll('.videoPopup-btn').forEach(function (el) { label(el, 'Play video'); });
    // "Show more" filter toggles whose only child is an icon
    document.querySelectorAll('[data-show-more-btn]').forEach(function (el) {
      var scope = el.getAttribute('data-show-more-btn') || 'options';
      label(el, 'Show more ' + scope);
    });
    // Loading-skeleton product cards: placeholder content with SR-hidden text.
    // Hide the whole skeleton from assistive tech until real content replaces it.
    document.querySelectorAll('.product-item--loadingNoInfo').forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
    });
    // Decorative unlabeled SVG icons (e.g. rating stars) -> hide from a11y tree
    document.querySelectorAll('svg[role="img"]:not([aria-label]):not([aria-labelledby])').forEach(function (svg) {
      if (!svg.querySelector('title') && !svg.closest('a,button,[role="button"],[role="link"]')) {
        svg.setAttribute('aria-hidden', 'true');
      }
    });
    // Iframes without a title (video embeds, widgets)
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      f.setAttribute('title', /youtu|vimeo|video/i.test(src) ? 'Video player' : 'Embedded content');
    });
  }

  if (document.readyState !== 'loading') pass();
  else document.addEventListener('DOMContentLoaded', pass);
  // Re-run for a few seconds to catch async widgets (slick, lazy carousels)
  var tries = 0;
  var iv = setInterval(function () { pass(); if (++tries >= 8) clearInterval(iv); }, 700);
  // And observe further DOM mutations
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { pass(); });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener('DOMContentLoaded', function () { mo.observe(document.body, { childList: true, subtree: true }); });
    // stop observing after 20s to avoid overhead
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
})();
